export default __webpack_public_path__ + "static/media/freecodecamp.c66f478f.png";